import React, { useCallback, useEffect, useState } from "react";
// import { useAuth } from "../../../context/AuthContext.jsx";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { MdOutlineRefresh, MdTrendingUp, MdBarChart, MdAssessment, MdLogout } from "react-icons/md";
import { useAuth } from "../../../context/AuthContext";
import { GetDataBranch, GetDataKPI } from "../../../../api/GetData";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

const baseURL = import.meta.env.VITE_API_URL;

const KPIDashboard = () => {
  const { authData, business: businessFromContext } = useAuth();
  const navigate = useNavigate();

  const [salesData, setSalesData] = useState([]);
  const [afterSalesData, setAfterSalesData] = useState([]);
  const [branchCode, setBranchCode] = useState("");
  const [branchOptions, setBranchOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const business = businessFromContext || localStorage.getItem("business");

  useEffect(() => {
    document.title = `${business} KPI Dashboard`;
  }, [business]);

  const userData = authData || JSON.parse(localStorage.getItem("dataLogin") || "null");
  const branchAuthority = userData?.data?.BranchAuthority;
  // const branches = branchAuthority.split("\u0001").filter(Boolean).join(",");
  const branches = branchAuthority.split("\u0001").filter(Boolean).map(branch => `'${branch}'`).join(",");
  // console.log("branches", branches);

  useEffect(() => {
    const fetchBranchOptions = async () => {
      try {

        const [response] = await GetDataBranch({
          busCode: business,
          branchCode: branches
        });
        // console.log("response", response);
        setBranchOptions(response);
      } catch (error) {
        toast.error("Gagal mengambil data cabang.");
        console.error("Error fetching branch options:", error);
      }
    };

    fetchBranchOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchKpiData = useCallback(async () => {
    try {
      setLoading(true);

      // const resSales = await axios.get(`${baseURL}/get/kpi/sales?BusinessCode=${business}&BranchCode=${branchCode}`);

      // const resAfterSales = await axios.get(`${baseURL}/get/kpi/aftersales?BusinessCode=${business}&BranchCode=${branchCode}`);

      const resKPI = await GetDataKPI({
        busCode: business,
        branchCode: branchCode
      });

      setSalesData(resKPI.Sales);
      setAfterSalesData(resKPI.AfterSales);
    } catch (error) {
      toast.error("Gagal mengambil data KPI.");
      console.error("Error fetching KPI data:", error);
      setSalesData([]);
      setAfterSalesData([]);
    } finally {
      setLoading(false);
    }
  }, [business, branchCode]);

  useEffect(() => {

    if (branchCode) {
      fetchKpiData();

      const interval = setInterval(() => {
        fetchKpiData();
      }, 1800000);

      return () => clearInterval(interval);

    }
  }, [branchCode, business, fetchKpiData]);


  const formatCurrency = (value) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const handleLogout = () => {
    // Clear localStorage
    localStorage.clear();

    // Clear all cookies
    document.cookie.split(";").forEach((c) => {
      const eqPos = c.indexOf("=");
      const name = eqPos > -1 ? c.substr(0, eqPos) : c;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });

    // Navigate to /kpi
    navigate("/kpi");
  };


  return (
    <div className="h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 dark:from-gray-900 dark:via-blue-900 dark:to-indigo-900 flex flex-col">
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />

      {/* Compact Header Section */}
      <div className="bg-gradient-to-r from-primary-600 to-blue-600 dark:from-primary-800 dark:to-blue-800 shadow-lg flex-shrink-0">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <MdAssessment className="text-2xl text-white mr-3" />
              <h1 className="text-2xl font-bold text-white">KPI Dashboard</h1>
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg shadow-sm hover:shadow-md transition-all text-sm font-medium"
              title="Logout"
            >
              <MdLogout className="text-lg" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="flex-1 flex flex-col container mx-auto px-4 py-4 overflow-hidden">
        {/* Compact Controls Section */}
        <div className="bg-white/70 dark:bg-gray-800/70 backdrop-blur-sm rounded-xl shadow-md p-4 mb-4 border border-white/20 flex-shrink-0">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex items-center gap-3">
              <label htmlFor="branchSelect" className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
                <MdBarChart className="inline mr-1" />
                Cabang:
              </label>
              <select
                id="branchSelect"
                value={branchCode}
                onChange={(e) => setBranchCode(e.target.value)}
                className="px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:border-primary-500 focus:ring-1 focus:ring-primary-200 transition-all text-sm min-w-48"
              >
                <option value="">-- Pilih Cabang --</option>
                {branchOptions.map((branch, index) => (
                  <option key={index} value={branch.KodeCabang}>
                    {branch.NamaCabang}
                  </option>
                ))}
              </select>
              {branchCode && (
                <button
                  onClick={fetchKpiData}
                  disabled={loading}
                  className="p-2 bg-primary-600 hover:bg-primary-700 disabled:bg-gray-400 text-white rounded-lg shadow-sm hover:shadow-md transition-all"
                >
                  <MdOutlineRefresh className={`text-lg ${loading ? 'animate-spin' : ''}`} />
                </button>
              )}
            </div>

            <div className="flex items-center text-sm">
              <MdTrendingUp className="text-primary-600 dark:text-primary-400 mr-2" />
              <span className="text-gray-600 dark:text-gray-400 mr-2">Update:</span>
              <span className="font-medium text-gray-900 dark:text-white">{dayjs().tz("Asia/Jakarta").format("DD MMM YYYY")}</span>
            </div>
          </div>
        </div>

        {/* Loading State - Card Skeleton */}
        {loading ? (
          <div className="flex-1 grid grid-cols-1 xl:grid-cols-2 gap-4 overflow-hidden">
            {[1, 2].map((i) => (
              <div
                key={i}
                className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-white/20 overflow-hidden flex flex-col animate-pulse"
              >
                {/* Skeleton Card Header */}
                <div className="bg-gray-300 dark:bg-gray-600 p-3 flex-shrink-0">
                  <div className="flex items-center">
                    <div className="w-5 h-5 bg-gray-400 dark:bg-gray-500 rounded mr-3"></div>
                    <div className="h-5 bg-gray-400 dark:bg-gray-500 rounded w-24"></div>
                  </div>
                </div>

                {/* Skeleton Card Content */}
                <div className="flex-1 p-4">
                  {/* Skeleton Table Header */}
                  <div className="flex justify-between items-center mb-3 pb-2 border-b border-gray-200 dark:border-gray-600">
                    <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-16"></div>
                    <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-12"></div>
                    <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-16"></div>
                    <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-16"></div>
                  </div>

                  {/* Skeleton Table Rows */}
                  {[1, 2, 3, 4, 5].map((row) => (
                    <div key={row} className="flex justify-between items-center py-2 border-b border-gray-100 dark:border-gray-700">
                      <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20"></div>
                      <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
                      <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
                      <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          /* Data Cards */
          <div className="flex-1 grid grid-cols-1 xl:grid-cols-2 gap-4 overflow-hidden">
            {[
              { title: "Sales", data: salesData, icon: MdTrendingUp, gradient: "from-emerald-500 to-teal-600" },
              { title: "After Sales", data: afterSalesData, icon: MdBarChart, gradient: "from-blue-500 to-indigo-600" },
            ].map((section, i) => (
              <div
                key={i}
                className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-white/20 overflow-hidden flex flex-col"
              >
                {/* Compact Card Header */}
                <div className={`bg-gradient-to-r ${section.gradient} p-3 flex-shrink-0`}>
                  <div className="flex items-center text-white">
                    <section.icon className="text-xl mr-3" />
                    <h2 className="text-lg font-bold">{section.title}</h2>
                  </div>
                </div>

                {/* Card Content */}
                <div className="flex-1 overflow-hidden">
                  {section.data.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-full p-6">
                      <MdBarChart className="text-3xl text-gray-400 mb-2" />
                      <p className="text-gray-500 dark:text-gray-400 text-sm text-center">
                        Data tidak tersedia
                      </p>
                      <p className="text-xs text-gray-400 dark:text-gray-500 mt-1 text-center">
                        Pilih cabang untuk melihat data KPI
                      </p>
                    </div>
                  ) : (
                    <div className="overflow-auto h-full">
                      <table className="w-full text-sm">
                        <thead className="sticky top-0 bg-gray-50 dark:bg-gray-700">
                          <tr className="border-b border-gray-200 dark:border-gray-600">
                            <th className="text-left py-2 px-3 font-semibold text-gray-700 dark:text-gray-300">Item</th>
                            <th className="text-right py-2 px-2 font-semibold text-gray-700 dark:text-gray-300">Target</th>
                            <th className="text-right py-2 px-2 font-semibold text-gray-700 dark:text-gray-300">Bulan Ini</th>
                            <th className="text-right py-2 px-2 font-semibold text-gray-700 dark:text-gray-300">Bulan Lalu</th>
                          </tr>
                        </thead>
                        <tbody>
                          {section.data.map((item, index) => {
                            const achievement = item.IsMoney ?
                              (item.M / item.Target * 100) :
                              (item.M / item.Target * 100);

                            return (
                              <tr
                                key={index}
                                className="border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td className="py-2 px-3">
                                  <div className="font-medium text-gray-900 dark:text-white text-sm">
                                    {item.TranType}
                                  </div>
                                </td>
                                <td className="py-2 px-2 text-right font-medium text-gray-700 dark:text-gray-300 text-xs">
                                  {item.IsMoney ? formatCurrency(item.Target) : item.Target.toLocaleString()}
                                </td>
                                <td className="py-2 px-2 text-right">
                                  <div className="font-semibold text-gray-900 dark:text-white text-xs">
                                    {item.IsMoney ? formatCurrency(item.M) : item.M.toLocaleString()}
                                  </div>
                                </td>
                                <td className="py-2 px-2 text-right font-medium text-gray-600 dark:text-gray-400 text-xs">
                                  {item.IsMoney ? formatCurrency(item["M-1"]) : item["M-1"].toLocaleString()}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default KPIDashboard;
